import { Point } from '../utils/point';
import { ConfigurationEdge } from './configuration-edge';

export class ConfigurationJamb {
  id?: string;
  havePolish: boolean;
  have45DegreesSideCut: boolean;
  startPoint: Point;
  endPoint: Point;
  height: number;
  verticalWorkbenchConfigurationEdges: ConfigurationEdge[];
  horizontalWorkbenchConfigurationEdge?: ConfigurationEdge;

  constructor(
    startPoint: Point,
    endPoint: Point,
    verticalConfigurationEdges: ConfigurationEdge[],
    horizontalConfigurationEdge?: ConfigurationEdge
  ) {
    this.startPoint = startPoint;
    this.endPoint = endPoint;
    this.verticalWorkbenchConfigurationEdges = verticalConfigurationEdges;
    this.horizontalWorkbenchConfigurationEdge = horizontalConfigurationEdge;
  }
}
